import { Injectable } from '@angular/core';

@Injectable()
export class RequestStateService {

  private lastUnauthorizedUrl: string;

  constructor() { }

  setLastUnauthorizedUrl(url: string) {
    if (url.indexOf('/login') == -1) {
      this.lastUnauthorizedUrl = url;
    }
  }

  getLastUnauthorizedUrl(): string {
    return this.lastUnauthorizedUrl;
  }

  clearLastUnauthorizedUrl() {
    this.lastUnauthorizedUrl = undefined;
  }

}
